import { LocationsResponse } from '@/services/locations';
import { RM_PREFIX, RM_GROUP_CARD_ID, RM_GROUP_IMAGE } from './constants';

type TranslateFunction = (key: string) => string;

export const groupRmLocations = (
  locations: LocationsResponse[],
  isSalfa: boolean,
  t: TranslateFunction,
): LocationsResponse[] => {
  if (!isSalfa) {
    return locations;
  }

  const rmLocations = locations.filter((l) => l.locationName.startsWith(RM_PREFIX));

  if (rmLocations.length === 0) {
    return locations;
  }

  const rmGroupCard: LocationsResponse = {
    ...rmLocations[0],
    id: RM_GROUP_CARD_ID,
    locationName: t('REGION_METROPOLITANA'),
    address: `${rmLocations.length} ${t('LOCATIONS_AVAILABLE')}`,
    image: RM_GROUP_IMAGE,
  };

  // Locations arrive sorted by their admin-configured order; the group card
  // takes the slot of the best-ranked RM location.
  const firstRmIndex = locations.findIndex((l) => l.locationName.startsWith(RM_PREFIX));
  const result: LocationsResponse[] = locations.filter((l) => !l.locationName.startsWith(RM_PREFIX));

  result.splice(firstRmIndex, 0, rmGroupCard);

  return result;
};
